import { render, staticRenderFns } from "./PMChartVersionsTableRow.vue?vue&type=template&id=0b02b2e0&"
import script from "./PMChartVersionsTableRow.vue?vue&type=script&lang=ts&"
export * from "./PMChartVersionsTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartVersionsTableRow.vue?vue&type=style&index=0&id=0b02b2e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports